import type { DriverRow } from "@/types/driver";

export function applyTagFilters(drivers: DriverRow[], tagFilters: Record<string, string[]>): DriverRow[] {
  const activeFilters = Object.entries(tagFilters).filter(([, values]) => values.length > 0);
  if (activeFilters.length === 0) return drivers;

  return drivers.filter((d) =>
    activeFilters.every(([tagId, allowedValues]) => {
      const values = d.tags[tagId];
      return values != null && values.some((v) => allowedValues.includes(v));
    }),
  );
}

export function applyTagSort(drivers: DriverRow[], tagSort: { tagId: string; direction: "asc" | "desc" }): DriverRow[] {
  return [...drivers].sort((a, b) => {
    const aVal = a.tags[tagSort.tagId]?.[0] ?? "";
    const bVal = b.tags[tagSort.tagId]?.[0] ?? "";
    const cmp = aVal.localeCompare(bVal);
    return tagSort.direction === "desc" ? -cmp : cmp;
  });
}
